module.exports = __webpack_public_path__ + "img/moto.ab965ccc.png";